module.exports = __webpack_public_path__ + "static/media/banner@768.6c3a2da6.png";